//Common
import { MARCA_FIM_CSV } from "@/common/constantes";
import { fn_getLimit } from "@/common/utils/paginacao";

//Util
import {
  showMensagemErro,
  showMensagemErroApi,
} from "@/frontend/utils/mensagens";

//API
import api from "./api";

//Rotas de listagem
export const ROTA_LISTAR = {
  TENANT: "/tenant/listar",
  PERFIL: "/perfil/listar",
  USUARIO: "/usuario/listar",

  MENU: "/menu/listar",
  TELA: "/tela/listar",

  ACESSO_TELA_PERFIL: "/acesso_tela_perfil/listar",

  AUTORIZACAO: "/autorizacao/listar",
  AUTORIZACAO_LOG: "/autorizacao_log/listar",

  JOB: "/job/listar",
  JOB_LOG: "/job_log/listar",

  PARAMETRIZACAO: "/parametrizacao/listar",
  PARAMETRIZACAO_TENANT: "/parametrizacao_tenant/listar",

  LOG_ALTERACAO: "/log_alteracao/listar",
  LOG_LEITURA_DOCUMENTO_IA: "/log_leitura_documento_ia/listar",
  LOG_ALTERACAO_PARAM: "/log_alteracao_param/listar",

  NOTIFICACAO_TIPO: "/notificacao_tipo/listar",
  NOTIFICACAO_USUARIO: "/notificacao_usuario/listar",

  FERIADO: "/feriado/listar",

  PESSOA_CONTA_BACARIA: "/pessoa_conta_bancaria/listar",

  EMPRESA: "/empresa/listar",
  FILIAL: "/filial/listar",
  FILIAL_ATENDIMENTO: "/filial_atendimento/listar",
  FORNECEDOR: "/fornecedor/listar",
  FORNECEDOR_CODIGO_CONTABIL: "/fornecedor_codigo_contabil/listar",

  SETOR: "/setor/listar",
  BANDEIRA: "/bandeira/listar",

  CENTRO_CUSTO: "/centro_custo/listar",
  CENTRO_CUSTO_QTDE_COLAB: "/centro_custo_qtde_colab/listar",
  CENTRO_CUSTO_CODIGO_CONTABIL: "/centro_custo_codigo_contabil/listar",

  CONTA_TENANT: "/conta_tenant/listar",
  CONTA_TENANT_CODIGO_CONTABIL: "/conta_tenant_codigo_contabil/listar",

  AREA: "/area/listar",
  PERFIL_AREA: "/perfil_area/listar",

  ALCADA: "/alcada/listar",

  CONTA_GRUPO: "/conta_grupo/listar",
  CONTA_NATUREZA: "/conta_natureza/listar",
  CONTA: "/conta/listar",
  PLANO_CONTA: "/plano_conta/listar",

  BANCO: "/banco/listar",
  IMPOSTO: "/imposto/listar",
  FORMA_PAGAMENTO: "/forma_pagamento/listar",
  TIPO_DOCUMENTO: "/tipo_documento/listar",
  INDICE_REAJUSTE: "/indice_reajuste/listar",
  INDICE_REAJUSTE_PERC: "/indice_reajuste_perc/listar",

  //Rotas específicas
  TENANT_LOGIN: "/tenant/listarTenantLogin",

  AUTORIZACAO_PERFIS_LIBERADOS: "/autorizacao_perfil/listarPerfisLiberados",

  CAMPO_CONTRATO: "/campo_contrato/listar",
  CAMPO_CONTRATO_CONTA_GRUPO: "/campo_contrato_conta_grupo/listar",

  SOLICITACAO: "/solicitacao/listar",
  SOLICITACAO_CONTA: "/solicitacao_conta/listar",
  //SOLICITACAO_CENTRO_CUSTO: "/solicitacao_centro_custo/listar",
  SOLICITACAO_CONTRATO: "/solicitacao_contrato/listar",
  SOLICITACAO_ANEXO: "/solicitacao_anexo/listar",
  SOLICITACAO_PAG: "/solicitacao_pag/listar",
  SOLICITACAO_PAG_ANEXO: "/solicitacao_pag_anexo/listar",
  SOLICITACAO_PAG_LOG: "/solicitacao_pag_log/listar",
  SOLICITACAO_PAG_CONFERENCIA: "/solicitacao_pag_conferencia/listar",
  SOLICITACAO_APROVACAO: "/solicitacao_aprovacao/listar",
  SOLICITACAO_APROVACAO_LOG_PAG: "/solicitacao_aprovacao_log_pag/listar",
  SOLICITACAO_REAJUSTE: "/solicitacao_reajuste/listar",
  SOLICITACAO_CORRECAO: "/solicitacao_correcao/listar",

  PRODUTO_GRUPO: "/produto_grupo/listar",

  RESUMO_VENDA: "/resumo_venda/listar",
  RESUMO_VENDA_GRUPO: "/resumo_venda_grupo/listar",

  META_EMPRESA: "/meta_empresa/listar",
  PREVISAO_EMPRESA_VAR: "/previsao_empresa_var/listar",

  NOTA_ENTRADA: "/nota_entrada/listar",

  //ROTAS ESPECÍFICAS (QUE NÃO SÃO A PADRÃO LISTAR)
  FERIADO_PERIODO: "/feriado/listarFeriadoPeriodo",
  CAMPO_CONTRATO_CAMPOS_GRUPO_CONTA: "/campo_contrato/listarCamposGrupoConta",
  PAGAMENTOS_SOLICITACAO: "/solicitacao_pag/listarPagamentosSolicitacao",
  ANEXOS_PAG_SOLICITACAO: "/solicitacao_pag_anexo/listarAnexosPagSolicitacao",
  RESUMO_VENDA_SUM: "/resumo_venda/sumValorResumo",
  DASHBOARD_PAGAMENTOS: "/dashboard/listarPagamentos", // ATENDIMENTO_FILIAL_POR_DIA_SEMANA:
  //   "filial_atendimento/listarAtendimentoFilialPorDiaSemana",
};

/*
 * Retorna a lista SEM paginação, conforme uma rota cadastrada no banco
 */
export async function api_executarRotaList(rotaFiltros, idTenant) {
  let result = [];
  try {
    if (idTenant) {
      rotaFiltros += `&id_tenant=${idTenant}`;
    }

    const { data } = await api.get(`${rotaFiltros}`);

    if (data?.items) {
      //se for um retorno com dados de paginação, obter apenas os itens
      result = data.items;
    } else {
      result = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "listar os dados");
  }
  return result;
}

/*
 * Retorna a lista COM paginação, conforme rota e filtros
 */
export async function api_listarPage(rotaListar, page, filtros, limit) {
  let result = {
    pages: 0,
    count: 0,
    items: [],
    offset: 0,
    limit: 0,
    totais: [],
  };
  try {
    if (!limit) {
      limit = fn_getLimit(page, 0);
    }

    const { data } = await api.get(
      `${rotaListar}?page=${page}&limit=${limit}&${filtros ? filtros : ""}`,
    );

    result = {
      pages: data.pages,
      count: data.total,
      items: data.items,
      limit: data.limit,
      offset: data.offset,
      totais: data?.totais, //opcional: Retorna o totalizador dos registros de todas as páginas
    };
  } catch (error) {
    showMensagemErroApi(error, "listar os dados");
  }
  return result;
}

/*
 * Retorna a lista SEM paginação, conforme rota e filtros
 */
export async function api_listar(rotaListar, filtros) {
  let result = [];
  try {
    const { data } = await api.get(`${rotaListar}?${filtros ? filtros : ""}`);

    if (data?.items) {
      //se for um retorno com dados de paginação, obter apenas os itens
      result = data.items;
    } else {
      result = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "listar os dados");
  }
  return result;
}

/*
 * Lista os registros ATIVOS e também os INATIVOS que possuem valor informado.
 * Utilizado nas telas de valores do pagamento (contas de desconto/despesa/juros/multa e impostos):
 * o registro inativo com valor precisa aparecer, senão o total não fecha com o detalhe.
 * @rotaListar: Rota de listagem (Ex: ROTA_LISTAR.CONTA)
 * @filtros: Filtros além da situação (Ex: "tipo=D")
 * @valores: Objeto {id: valor} com os valores já informados
 * Sem inativo com valor, faz a mesma consulta de antes (somente os ativos).
 */
export async function api_listarAtivosEComValor(rotaListar, filtros, valores) {
  const ativos = await api_listar(
    rotaListar,
    `situacao=A${filtros ? `&${filtros}` : ""}`,
  );

  //Ids com valor que não estão entre os ativos
  let idsFaltantes = Object.entries(valores || {})
    .filter(([, valor]) => Number(valor || 0) > 0)
    .map(([id]) => id)
    .filter((id) => !ativos.some((item) => item.id == id));

  if (idsFaltantes.length == 0) {
    return ativos;
  }

  //Busca sem o filtro da situação para obter os inativos com valor
  let inativos = (await api_listar(rotaListar, filtros)).filter((item) =>
    idsFaltantes.some((id) => id == item.id),
  );

  //Se ainda faltar algum (Ex: o cadastro mudou e não atende mais ao filtro), busca sem filtro
  idsFaltantes = idsFaltantes.filter(
    (id) => !inativos.some((item) => item.id == id),
  );

  if (idsFaltantes.length > 0 && filtros) {
    const demais = (await api_listar(rotaListar)).filter((item) =>
      idsFaltantes.some((id) => id == item.id),
    );
    inativos = [...inativos, ...demais];
  }

  return [...ativos, ...inativos];
}

/*
 * Lista o histórico da posse do pagamento: o log de cada vez que a posse foi salva (data/hora e usuário),
 * em ordem crescente. Vem do log de alteração da data da posse do pagamento
 */
export async function api_listarHistoricoPosse(idPagamento) {
  return await api_listar(
    ROTA_LISTAR.LOG_ALTERACAO,
    `tabela=solicitacao_pag&id_tabela=${idPagamento}&campo=data_posse`,
  );
}

/*
 * Lista os logs da última solicitação com situação aprovada de determinada solicitação/pagamento
 */
export async function api_listarLogsUltimaSolicitacaoAprovada(
  idSolicitacao,
  numPag,
) {
  let ret;
  try {
    const { data } = await api.get(
      `solicitacao_aprovacao_log_pag/listarLogsUltimaSolicitacaoAprovada?id_solicitacao=${idSolicitacao}&num_pag=${numPag}`,
    );

    if (data) {
      ret = data;
    }
  } catch (error) {
    showMensagemErroApi(error, "listar logs da última solicitação aprovada");
  }
  return ret;
}

/*
 * Lista os dados dos pagamentos para gerar o arquivo CSV
 */
// export async function api_listarDadosPagamentosCSV(filtros) {
//   let ret;
//   try {
//     const { data } = await api.get(
//       `solicitacao_pag/listarPagamentosCSV?${filtros}`,
//     );

//     if (data) {
//       ret = data;
//     }
//   } catch (error) {
//     if (
//       error.response?.data?.includes("Invalid string length") ||
//       error.message?.includes("Invalid string length")
//     ) {
//       showMensagemErro(
//         "Não foi possível gerar o csv. Diminua o filtro da consulta.",
//       );
//     } else {
//       showMensagemErroApi(error, "listar dados para gerar o CSV");
//     }
//   }
//   return ret;
// }

// export async function api_listarDadosPagamentosCSV_novo(filtros) {
//   try {
//     const response = await api.get(
//       `solicitacao_pag/listarPagamentosCSV_novo?${filtros}`,
//       { responseType: "blob" },
//     );

//     //Se não veio conteúdo (204, ou blob vazio), não tem dados para gerar o CSV
//     if (response.status == 204 || !response.data || response.data.size == 0) {
//       return null;
//     }

//     //Extrai o nome do arquivo do header Content-Disposition enviado pelo back-end
//     const contentDisposition = response.headers["content-disposition"];
//     const match = contentDisposition?.match(/filename="(.+)"/);
//     const nomeArquivo = match ? match[1] : "pagamentos.csv";

//     return { blob: response.data, nomeArquivo };
//   } catch (error) {
//     const status = error.response?.status;

//     //Timeout/erro de gateway - a consulta demorou demais ou o servidor caiu no meio
//     if (status == 502 || status == 504 || error.code == "ECONNABORTED") {
//       showMensagemErro(
//         "A consulta demorou muito para ser processada. Diminua o filtro do período e tente novamente.",
//       );
//       return "erro"; // valor diferente de null, para distinguir de "sem dados"
//     }

//     if (
//       error.response?.data?.includes?.("Invalid string length") ||
//       error.message?.includes("Invalid string length")
//     ) {
//       showMensagemErro(
//         "Não foi possível gerar o csv. Diminua o filtro do período da consulta.",
//       );
//       return "erro";
//     }

//     showMensagemErroApi(error, "listar dados para gerar o CSV");
//     return "erro";
//   }
// }

/*
 * Gera o CSV dos pagamentos pela rota que envia o arquivo em lotes (para consultas com muitos dados)
 * Retorna { blob, nomeArquivo }, null (nenhum registro) ou "erro"
 */
export async function api_listarDadosPagamentosCSVStream(filtros) {
  try {
    const response = await api.get(
      `solicitacao_pag/listarPagamentosCSVStream?${filtros}`,
      { responseType: "blob" },
    );

    //Se não veio conteúdo (204, ou blob vazio), não tem dados para gerar o CSV
    if (response.status == 204 || !response.data || response.data.size == 0) {
      return null;
    }

    const blob = response.data;

    //O arquivo termina com a marca de fim + JSON com a qtde de linhas e o nome do arquivo.
    //Se a marca não existir, o servidor não concluiu o envio (arquivo incompleto)
    const textoFinal = await blob.slice(-2048).text();
    const posicaoMarca = textoFinal.lastIndexOf(MARCA_FIM_CSV);

    let dadosFim = null;
    if (posicaoMarca >= 0) {
      try {
        dadosFim = JSON.parse(
          textoFinal.substring(posicaoMarca + MARCA_FIM_CSV.length),
        );
      } catch {
        dadosFim = null;
      }
    }

    if (!dadosFim?.nome_arquivo) {
      showMensagemErro(
        "O arquivo CSV não foi recebido por completo. Tente gerar novamente.",
      );
      return "erro";
    }

    //Remove do arquivo a quebra de linha + marca de fim + JSON
    const tamanhoFim = new TextEncoder().encode(
      "\r\n" + textoFinal.substring(posicaoMarca),
    ).length;

    return {
      blob: blob.slice(0, blob.size - tamanhoFim, "text/csv;charset=utf-8;"),
      nomeArquivo: dadosFim.nome_arquivo,
    };
  } catch (error) {
    //Como a resposta é do tipo blob, converte a mensagem de erro enviada pelo backend para texto
    if (error.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch {
        error.response.data = "";
      }
    }

    showMensagemErroApi(error, "gerar o CSV");
    return "erro";
  }
}
